export default __webpack_public_path__ + "static/media/shrike.7fd3441e.png";